import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {IEmailPlayersDialogData} from "../../../interfaces/IEmailPlayersDialogData";
import {GameStateEnum} from "../../../enum/GameStateEnum";

export interface IEmailPlayersGameChoice {
  /** The games the picker offers; empty means the admin can email no game from here. */
  games: IGameQueryResult[];
  prefillGameId: string | null;
  /** Set when there is exactly one game to send to, so the dialog names it instead of showing a picker. */
  singleGame: IGameQueryResult | undefined;
}

export function chooseEmailGames(allGamesP: IGameQueryResult[],
                                 dialogDataP: IEmailPlayersDialogData,
                                 canEmailGameP: (gameIdP: string) => boolean): IEmailPlayersGameChoice {
  const emailable = allGamesP.filter(gameP => gameP.State !== GameStateEnum.Draft && canEmailGameP(gameP.Id));

  // The page names its game: send to that game or to none, never quietly to another one.
  if (dialogDataP.gameId) {
    const page_game = emailable.find(gameP => gameP.Id === dialogDataP.gameId);
    if (!page_game) {
      return {games: [], prefillGameId: null, singleGame: undefined};
    }

    const games = dialogDataP.lockGame ? [page_game] : emailable;
    return {games, prefillGameId: page_game.Id, singleGame: games.length === 1 ? page_game : undefined};
  }

  const only_game = emailable.length === 1 ? emailable[0] : undefined;
  return {games: emailable, prefillGameId: only_game?.Id ?? null, singleGame: only_game};
}
